import React, { ReactNode } from "react";
import { Keyboard, TouchableWithoutFeedback, View } from "react-native";

type KeyboardAvoidingWrapperProps = {
  children: ReactNode;
};

const KeyboardAvoidingWrapper: React.FC<KeyboardAvoidingWrapperProps> = ({
  children,
}) => {
  const handlePressOutside = () => {
    Keyboard.dismiss();
  };

  return (
    <TouchableWithoutFeedback onPress={handlePressOutside}>
      <View style={{ flex: 1 }}>{children}</View>
    </TouchableWithoutFeedback>
  );
};

export default KeyboardAvoidingWrapper;
